function isInManageTransactionsPage() {
  return $("#manageTransactionsByGrant").length > 0;
}

if (isInManageTransactionsPage()) {
  var dialogSelector = "#start-transaction-review";
  //        var primaryHref = "";
  //        var baseHref = "";
  //        var $interruptedElement = ".start-transaction-review";
  //        console.log($('#ui-datepicker-div').datepicker("option"));
  var receiptValidationDate = $("#receiptValidationDate").val();
  var paymentValidationDate = $("#paymentValidationDate").val();
  //
  //
  //        console.log("validation dates");
  //        console.log(receiptValidationDate);
  //        console.log(paymentValidationDate);
  //
  //        var paymentDiv;
  //        var receiptDiv;
  //        var divMoved = false;
  $("#paymentValidationDate").on("change", function () {
    paymentValidationDate = $(this).val();
  });
  $("#receiptValidationDate").on("change", function () {
    receiptValidationDate = $(this).val();
  });
  $("input#paymentDate:enabled").datepicker({
    showOn: "both",
    buttonImageOnly: false,
    buttonText: "Select date",
    dateFormat: "dd/mm/yy",
    selectOtherMonths: true,
    //            minDate: paymentValidationDate,

    beforeShow: function (dateText, obj) {
      setTimeout(function () {

        $("#start-transaction-review").append($("#ui-datepicker-div"));

        $("#ui-datepicker-div").css("top", "153px");
        $("#ui-datepicker-div").css("left", "14px");
        $("#ui-datepicker-div").css("display", "block");
        $("#ui-datepicker-div").css("opacity", "1");
        //                        var validationDate = $('#paymentValidationDate').val();
        //                        validationDate = "20/08/2020";
        //                        paymentValidationDate = validationDate;
        //                        $('#receiptDate').datepicker('option', 'minDate', validationDate);
      }, 0);
    },
    onClose: function (dateText, obj) {
      $("#start-transaction-review #ui-datepicker-div").css("opacity", "0");
      $("#start-transaction-review #ui-datepicker-div").css("display", "none");
      $("body").append($("#ui-datepicker-div"));
    },
  });
  $("input#receiptDate:enabled").datepicker({
    showOn: "both",
    buttonImageOnly: false,
    buttonText: "Select date",
    dateFormat: "dd/mm/yy",
    //            minDate: receiptValidationDate,
    beforeShow: function (dateText, obj) {
      setTimeout(function () {

        $("#start-transaction-review").append($("#ui-datepicker-div"));

        $("#ui-datepicker-div").css("top", "293px");
        $("#ui-datepicker-div").css("left", "14px");
        $("#ui-datepicker-div").css("display", "block");
        $("#ui-datepicker-div").css("opacity", "1");
        //                        var validationDate = $('#receiptValidationDate').val();
        //                        validationDate = "25/08/2020";
        //                        $('#paymentDate').datepicker('option', 'minDate', validationDate);
        //                        receiptValidationDate = validationDate;
        //                    }
      }, 0);
    },
    onClose: function () {
      $("dialog #ui-datepicker-div").css("opacity", "0");
      $("dialog #ui-datepicker-div").css("display", "none");
      $("body").append($("#ui-datepicker-div"));
    },
  });

  //        $('#paymentValid').val('20/10/2020');

  //        $('.start-transaction-review').click(function(e){
  //            e.preventDefault();
  //            $('#receiptValidationDate').val('28/08/2020');
  //            $('#paymentValidationDate').val('20/08/2020');
  //            console.log("popup clickeddd");
  //            $('body').remove('.ui-datepicker');
  //            $interruptedElement = $(this);
  //            console.log("review popup clicked");
  //            var href = $(this).attr('href').split("&");
  //            console.log(href);
  //            var paymentDate = href[1].split("=")[1];
  //            var receiptDate = href[2].split("=")[1];
  //            primaryHref = $(this).attr('href');
  //            baseHref = href[0];
  //            $('#paymentDate').val(paymentDate);
  //            $('#receiptDate').val(receiptDate);
  //            $(this).attr('href', baseHref);
  //            getReviewalDates(baseHref.split("?")[1]);
  //            $('body').addClass('dialog-is-open');
  //            $(dialogSelector)[0].showModal();
  //        });

  //        $('#start-review').click(function(){
  //            console.log("proceed review clicked");
  //            var URI = $('.start-transaction-review').attr('href');
  //            window.location.assign( $interruptedElement.attr('href') );
  //        });

  //        $('#start-transaction-review .dialog-close').click(function(){
  //            console.log("transaction review cancel clicked");
  //            $interruptedElement.attr('href', primaryHref);
  //            $(dialogSelector)[0].close();
  //        });

  //        $('body').on('dialog.close',$(dialogSelector), function(e) {
  //            e.preventDefault();
  //
  //            if ( dialogSelector ) {
  //                console.log('dialog.close');
  //                $(dialogSelector)[0].close();
  //                $('body').removeClass('dialog-is-open');
  //            }
  //        });
}
